import React,{useState,useEffect} from 'react';

function App() {

  const [userInput,setUserInput]=useState('');

  const [finalUserInput,setFinalUserInput]=useState('');

  const [outputContainer,setOutputContainer]=useState();

  useEffect(()=>{
    fetchData();
  },[finalUserInput])

  const fetchData=()=>{
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': 'f95540051dmsh5bc4447a53bc30dp1b09afjsn82cbb3fc60d3',
        'X-RapidAPI-Host': 'ai-chatbot.p.rapidapi.com'
      }
    };
    
    fetch(`https://ai-chatbot.p.rapidapi.com/chat/free?uid=user1&message=+${userInput}`, options)
      .then(response=>{
        return response.json();
      })
      .then(data=>{
        setOutputContainer(data.chatbot)
      })
      .catch(err => console.error(err));
  
  }
  

  const submitHandler=(event)=>{
    event.preventDefault();
    setFinalUserInput(userInput);
  }

  return (
    <div className="container mt-5 text-center">
    <h3  className="font-effect-shadow-multiple fs-1 mt-2">AI Chatbot</h3>
    <h3  className="font-effect-shadow-multiple fs-1 mb-3">Created By Suraj Sahani</h3>
    <form onSubmit={submitHandler} >
       <div className="mb-3 ">
          <input type="text" className="form-control" value={userInput} onChange={(event)=> setUserInput(event.target.value)}/>
       </div>
       <div className="container text-center">
          <button type="submit" className="btn btn-primary mb-5">Send To Chatbot</button>
       </div>
    </form>
    {
  outputContainer?
    <div className="container text-center">
    <h3  className="font-effect-fire fs-1">You :{outputContainer.message}</h3>
    <h3  className="font-effect-neon fs-1">Chatbot :{outputContainer.response}</h3>
    </div>:
    <div className="container text-center">
    <h3  className="font-effect-neon fs-1">Please Type Something For Talking To AI Chatbot</h3>
    
    </div>
    
    }
 </div>
  );
}

export default App;
